// import { MODULE } from './../../helpers/security';

export default [
  {
    path: '/donations-over-the-phone',
    redirect: '/home',
    // component: () => import('./views/DonationOverThePhone.vue'),
    // meta: {
    // requiresAuth: true,
    // moduleCode: MODULE.DOTP
    // },
    children: [
      // {
      //   path: '',
      //   name: 'dotp-list',
      //   component: () => import('./views/DOTPList.vue'),
      // },
      // {
      //   path: ':id',
      //   name: 'users-view',
      //   component: () => import('./views/UserView.vue'),
      // }
    ]
  }
];